import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import ProductListOne from "../components/ProductListOne";
import RecommendedOne from "../components/RecommendedOne";

import DeliveryOne from "../components/DeliveryOne";

import FamilyPackOne from "../components/FamilyPackOne";
import NewArrivalOne from "../components/NewArrivalOne";
import ShippingOne from "../components/ShippingOne";

import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ColorInit from "../helper/ColorInit";

const HomePageOne = () => {
  return (
    <>
      <Preloader />
      <ColorInit color={false} />
      <HeaderOne />
      <BannerOne />
      <FeatureOne />
      <ProductListOne />
      <RecommendedOne />
      <DeliveryOne />
      <FamilyPackOne />
      <ShippingOne />
      <NewArrivalOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default HomePageOne;
